<template>
    <div>RDCD REPORT PAGE</div>
</template>